/**
 * Template views the assistant shows in the chat (design D1/D8): a proposal
 * tree with a create button, a change preview tree with an apply button, and
 * an interactive embeddable-wizard preview. Spread into `views/registry.ts`.
 */
import type { AgentViewComponent } from "./registry.js";
import { ChangeView } from "./templates/ChangeView.js";
import { ProposalView } from "./templates/ProposalView.js";
import { WizardPreviewView } from "./templates/WizardPreviewView.js";

export const templatesAgentViews: Record<string, AgentViewComponent> = {
  template_proposal: ProposalView,
  template_change: ChangeView,
  wizard_preview: WizardPreviewView,
};
